module.exports = __webpack_public_path__ + "media/images/lb/871-0ac1343641033116ef91c0443973473b.svg";